import { api } from './api';
import type {
  GenerateVendorEmailsResponse,
  SendVendorEmailResult,
  VendorEmailJobStatusResponse,
  VendorEmailsResponse,
  VendorEmailUpdateResponse,
  VendorEmailUpdateStatus,
} from '@exhale/contracts';

export type VendorEmailStatus = VendorEmailUpdateStatus;
export type { SendVendorEmailResult } from '@exhale/contracts';

export const reviewVendorEmailApi = {
  generate(reviewId: number, feedback?: Record<number, string>): Promise<GenerateVendorEmailsResponse> {
    const data = feedback ? { feedback } : {};
    return api.post<GenerateVendorEmailsResponse>(`/reviews/${reviewId}/vendor-emails/generate`, data);
  },

  getAll(reviewId: number): Promise<VendorEmailsResponse> {
    return api.get<VendorEmailsResponse>(`/reviews/${reviewId}/vendor-emails`);
  },

  getJobStatus(reviewId: number, jobId?: string): Promise<VendorEmailJobStatusResponse> {
    const query = jobId ? `?jobId=${encodeURIComponent(jobId)}` : '';
    return api.get<VendorEmailJobStatusResponse>(`/reviews/${reviewId}/vendor-emails/status${query}`);
  },

  updateStatus(
    reviewId: number,
    vendorTypeId: number,
    status: VendorEmailStatus
  ): Promise<VendorEmailUpdateResponse> {
    return api.patch<VendorEmailUpdateResponse>(`/reviews/${reviewId}/vendor-emails/${vendorTypeId}`, { status });
  },

  updateContent(
    reviewId: number,
    vendorTypeId: number,
    subject: string,
    content: string
  ): Promise<VendorEmailUpdateResponse> {
    return api.patch<VendorEmailUpdateResponse>(`/reviews/${reviewId}/vendor-emails/${vendorTypeId}`, { subject, content });
  },

  send(
    reviewId: number,
    vendorTypeId: number,
    vendorIds?: number[]
  ): Promise<SendVendorEmailResult> {
    return api.post<SendVendorEmailResult>(`/reviews/${reviewId}/vendor-emails/${vendorTypeId}/send`, { vendorIds });
  },
};
